import React, { Component } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import RenderRoute from "./components/Global/RenderRoute.js";

//Layout
import { Layout } from "./components/Views/Shared/Layout.js";
import LayoutServices from "./components/Views/Services/LayoutServices.js";
//Views
import Homepage from "./components/Views/Homepage/Homepage.js";
// import Recruitment from "./components/Views/Services/Recruitment/Recruitment.js";

import Assessment from "./components/Views/Assessment/Assessment.js";
import AboutUs from "./components/Views/AboutUs/AboutUs.js";
import { PrivacyPolicy } from "./components/Views/Shared/PrivacyPolicy.js";
import { Guidelines } from "./components/Views/Guidelines/Guidelines.js";
import Recruitment from "./components/Views/Recruitment/Recruitment.js";

/* Themes */
import defaultTheme from "./themes/default.json";

// STYLES
import "./styles/reset.scss";
import "./styles/config.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css";

//Moment Locale
import moment from "moment";
import "moment/locale/pt";
moment.locale("pt");

//aos css
// import "aos/dist/aos.css";

export default class App extends Component {
  render() {
    return (
      <ThemeProvider theme={defaultTheme}>
        <BrowserRouter>
          <Switch>
            {/* HOMEPAGE */}
            <RenderRoute exact path="/">
              <Layout>
                <Homepage />
              </Layout>
            </RenderRoute>

            {/* ABOUT US */}
            <RenderRoute exact path="/about-us">
              <Layout>
                <AboutUs />
              </Layout>
            </RenderRoute>

            {/* ASSESSMENT */}
            <RenderRoute exact path="/assessment">
              <Layout>
                <Assessment />
              </Layout>
            </RenderRoute>

            {/* RECRUITMENT */}
            <RenderRoute exact path="/recruitment">
              <Redirect to="/recrutamento" />
            </RenderRoute>
            <RenderRoute exact path={"/recrutamento"}>
              <Layout>
                <Recruitment />
              </Layout>
            </RenderRoute>

            {/* PRIVACY POLICY */}
            <RenderRoute exact path="/privacy-policy">
              <Layout>
                <PrivacyPolicy />
              </Layout>
            </RenderRoute>

            {/* important DELETE ALL BELLOW */}

            {window.location.hostname === "localhost" && (
              <RenderRoute exact path="/guidelines">
                <Guidelines />
              </RenderRoute>
            )}
          </Switch>
        </BrowserRouter>
      </ThemeProvider>
    );
  }
}
